module.exports = __webpack_public_path__ + "img/chevron-right.02c597f5.svg";